
import { LitElement, html } from "lit-element";
import { colorTheme } from "../../../../styles/color-theme";

export class DrawSettingsPopup extends LitElement {
	render() {
		return html`
            ${colorTheme}
            <style>
                :host {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100vw;
                    height: 100vh;
                    z-index: 9999;
                    display: flex;
                    justify-content: center;
                    background-color: #4e4e58b8;
                }

                .popup {
                    padding: 20px;
                    align-self: center;
                    background-color: var(--primary-color-variant1);
                }

                mwc-button {
                    --mdc-theme-primary: var(--secondary-color);
                    width: 100%
                }

                .title {
                    color: var(--secondary-color);
                }
            </style>
            <div class="popup">
                ${this.settingsHtml}
            </div>`;
	}

	close() {
		this.remove();
	}

	get properties() {
		return { settingsHtml: Object };
	}
}

window.customElements.define("inspx-draw-settings-popup", DrawSettingsPopup);
